export default __webpack_public_path__ + "static/media/dueDateChange.cc5d9cea.svg";